export function getTitleFromPath(path: string): string {
  const fileName = path.split('/').pop()?.split('.')[0];
  if (!fileName) return '';
  return toWords(fileName);
}

function toWords(fileName: string): string {
  return fileName
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
